import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import {
  UnsubscribeRequest,
  UnsubscribeResponse,
} from '../interfaces/subscription.interface';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  private readonly baseUrl: string = environment.messagingServiceBaseUrl;

  constructor(private http: HttpClient) { }

  public unsubscribe(token: string, active: boolean): Observable<UnsubscribeResponse> {
    const url = `${this.baseUrl}/subscriptions/update`;
    const body: UnsubscribeRequest = { active };
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.post<UnsubscribeResponse>(url, body, { headers });
  }
}


